export default __webpack_public_path__ + "static/media/KOD0085-min.76a397a8.webp";